import styles from './Welcome.module.css';
export function Welcome(props) {
  return (
    <div className={styles['container']}>
      <h1>Welcome to Table Tuck!</h1>
    </div>
  );
}
export default Welcome;
